module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/hash-base/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 329
// module chunks = 1